/**
 * 多标签页登录状态同步工具
 *
 * 场景：用户在标签页A已登录，在标签页B点击邀请链接注册新用户
 * 问题：标签页A不知道已经登出，仍显示旧用户信息
 * 解决：监听localStorage变化，自动同步清理状态
 */

import { useUserStore } from '@/store'
import router from '@/router'

/**
 * 初始化跨标签页状态同步
 * 应在应用启动时调用一次（如 main.ts）
 */
export function initStorageSync() {
  window.addEventListener('storage', async (e) => {
    // 监听 access_token 被清空（其他标签页登出/注册新用户）
    if (e.key === 'access_token' && !e.newValue) {
      console.log('[Storage Sync] 检测到其他标签页登出，同步清理本标签页状态')

      const userStore = useUserStore()

      // 如果当前标签页还认为已登录，需要同步清理
      if (userStore.isLoggedIn) {
        // 动态导入避免循环依赖
        const { resetAllStores } = await import('@/store')
        resetAllStores()

        // 如果当前不在登录/注册页，跳转到登录页
        const currentPath = window.location.pathname
        const isAuthPage = currentPath.includes('/user') || currentPath.includes('/login')

        if (!isAuthPage) {
          console.log('[Storage Sync] 当前页面需要登录，跳转到登录页')
          router.push({
            name: 'user',
            query: { redirect: encodeURIComponent(currentPath) },
          })
        }
      }
    }
  })

  console.log('[Storage Sync] 多标签页同步已初始化')
}
